import React, { useEffect, useState,useRef, useCallback } from "react";
import { Calendar, CheckSquare, List, Tag, Trash, Type } from "react-feather";
import { colorsList } from "../../Helper/Util";
import Modal from "../../../Modal/Modal";
import 'react-select-search/style.css'
import CustomInput from "../../../CustomInput/CustomInput";
import { uploadfile } from "../../../../services/tasks/tasks"
import { FiUsers } from "react-icons/fi";
import { MdOutlineLabel } from "react-icons/md";
import { GoChecklist } from "react-icons/go";
import { BsCalendarDate } from "react-icons/bs";
import { GrAttachment } from "react-icons/gr";
import { FaCcDiscover } from "react-icons/fa";
import { AiOutlineFileDone } from "react-icons/ai";
import { BiTask } from 'react-icons/bi'
import "./CardInfo.css";
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
// import { ICard, ILabel, ITask } from "../../../Interfaces/Kanban";
import Chip from "../../../Common/Chip";
import { CgProfile } from 'react-icons/cg'
import { Dropdown } from "react-bootstrap";
// import ImageViewer from "react-simple-image-viewer";

// interface CardInfoProps {
//   onClose: () => void;
//   card: ICard;
//   boardId: number;
//   updateCard: (boardId: number, cardId: number, card: ICard) => void;
// }
function CardInfo(props) {
  const { onClose, card, boardId, updateCard, boardMember } = props;
  console.log('props data :',props)
  const [selectedColor, setSelectedColor] = useState("");
  const [assignn, setAssign] = useState(false);
  const [members, setMembers] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false)
  const [file, setFile] = useState();
  const [subData, setSubData] = useState('');
  const [cardValues, setCardValues] = useState({
    ...card,
  });


  console.log("both at once", cardValues)
  const updateTitle = (value) => {
    setCardValues({ ...cardValues, title: value });
  };
  const handleImage = (e, value) => {
    console.log('new image:', e.target.files[0])
    const formdata = new FormData();

    console.log('new image:', e.target.files[0].name)
    let image = e.target.files[0]
    console.log('image 1:', image.File)
    formdata.append('myFile', image)
    uploadfile(formdata)
    let file = e.target.files[0].name

    formdata.append('myfile', file)

    setFile(file);
    console.log('file:', file)


    setCardValues({ ...cardValues, files: file });
    toast.success('Attachment file added successfully', {
      theme: "colored"
    })
    console.log('cardValues:', cardValues)

  };
  const updateDesc = (value) => {
    setCardValues({ ...cardValues, desc: value });
  };
  const subTask=(e)=>{
    addTask(subData)
    setSubData("");
  }
  const addLabel = (label) => {
    console.log("cardValues : ", cardValues);
    const index = cardValues.labels.findIndex(
      (item) => item.text === label.text
      );
      if (index > -1) return; //if label text already exist then return
      
      setSelectedColor("");
      setCardValues({
        ...cardValues,
      labels: [...cardValues.labels, label],
    });
  };

  const removeLabel = (label) => {
    const tempLabels = cardValues.labels.filter(
      (item) => item.text !== label.text
      );
      
      setCardValues({
        ...cardValues,
        labels: tempLabels,
      });
    };
    
    const addTask = (value) => {
      console.log('hello',value)
      const task = {
        id: parseInt(Date.now() + Math.random() * 2),
        completed: false,
        text: value,
      };
      setCardValues({
        ...cardValues,
        tasks: [...cardValues.tasks, task],
      });
    };
    
    const removeTask = (id) => {
      const tasks = [...cardValues.tasks];
      
      const tempTasks = tasks.filter((item) => item.id !== id);
      setCardValues({
        ...cardValues,
        tasks: tempTasks,
      });
    };
    
    const updateTask = (id, value) => {
      const tasks = [...cardValues.tasks];
      
      const index = tasks.findIndex((item) => item.id === id);
      if (index < 0) return;
      
      tasks[index].completed = value;
      
      setCardValues({
        ...cardValues,
        tasks,
      });
    };
    
    const calculatePercent = () => {
      if (!cardValues.tasks?.length) return 0;
      const completed = cardValues.tasks?.filter(
        (item) => item.completed
        )?.length;
        return (completed / cardValues.tasks?.length) * 100;
      };
      
      const updateDate = (date) => {
        if (!date) return;
        
        setCardValues({
          ...cardValues,
          date,
        });
      };
      const updateDueDate = (dueDate) => {
        // if (!date) return;
        
        setCardValues({
          ...cardValues,
          dueDate,
        });
      };

      const addAssign = (value) => {
        setCardValues({
          ...cardValues,
          assign: value,
        });
      };
      
      const updateAssign = (value) => {
        console.log('d\t\l',value)
        let arrMembers = members;
        arrMembers.push({ email: value.email,picture:value.profilePicture });

        setMembers(arrMembers);
        setCardValues({
          ...cardValues,
          // assign: [{ email: value }],
          assign: arrMembers,
        });
  };
  
  const updatePoints = (value) => {
    setCardValues({
      ...cardValues,
      points: value,
    });
  };

  

  useEffect(() => {
    updateCard(boardId, cardValues._id, cardValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardValues]);
  
  const calculatedPercent = calculatePercent();
  return (
    <Modal>
      <div className="cardinfo">
        <div className="newclass1">
          <div className="cardinfo-box">
            <div className="cardinfo-box-title">
              <Type />
              <p>Title</p>
            </div>
            <textarea
              // defaultValue={cardValues.title}
              // text={cardValues.title}
              placeholder="Enter Title"
              // onSubmit={updateTitle}
              onClick={(e)=>updateTitle(e.target.value)}
              />
          </div>

          <div className="cardinfo-box">
            <div className="cardinfo-box-title">
              <List />
              <p>Description</p>
            </div>
            <textarea
              defaultValue={cardValues.desc}
              placeholder="Enter description"
              onChange={(event)=> updateDesc(event.target.value)}
              />

          </div>
         
          <div>
            {cardValues.files ? (
              <img src={
                `${process.env.REACT_APP_API_URL_IMG}/${cardValues.files}`} alt="" className="card__image" />
            ) : (null)}
          </div>
          <div className="cardinfo-box-date">
            <div className="cardinfo-box-title">
              <Calendar />
              <p>Date</p>
            </div>
            <input 
            
              type="date"
              defaultValue={cardValues.date}
              min={new Date().toISOString().substring(0, 10)}
              onChange={(event) => updateDate(event.target.value)}
              
            />
            <span className="span-text">to</span>
              <input 
            
            type="date"
            defaultValue={cardValues.dueDate}
            min={new Date().toISOString().substring(0, 10)}
            onChange={(event) => updateDueDate(event.target.value)}
            
          />
            
          </div>

          <div className="cardinfo-box">
            <div className="cardinfo-box-title">
              <Tag />
              <p>Labels</p>
            </div>
            <div className="cardinfo-box-labels">
              {cardValues.labels?.map((item, index) => (
                <Chip key={index} item={item} removeLabel={removeLabel} />
              ))}
            </div>
            <ul>
              {colorsList.map((item, index) => (
                <li
                  key={index}
                  style={{ backgroundColor: item }}
                  className={selectedColor === item ? "li-active" : ""}
                  onClick={() => setSelectedColor(item)}
                />
              ))}
            </ul>
            <CustomInput
              text="Add Label"
              placeholder="Enter label text"
              onSubmit={(value) =>
                addLabel({ color: selectedColor, text: value })
              }
            />
          </div>

          <div className="cardinfo-box">
            <div className="cardinfo-box-title">
              <CheckSquare />
              <p>Subtask</p>
            </div>
            <div className="cardinfo-box-progress-bar">
              <div
                className="cardinfo-box-progress"
                style={{
                  width: `${calculatedPercent}%`,
                  backgroundColor: calculatedPercent === 100 ? "limegreen" : "",
                }}
              />
            </div>
            <div className="cardinfo-box-task-list">
              {cardValues.tasks?.map((item) => (
                <div key={item.id} className="cardinfo-box-task-checkbox">
                  <input
                    type="checkbox"
                    defaultChecked={item.completed}
                    onChange={(event) =>
                      updateTask(item._id, event.target.checked)
                    }
                  />
                  <p className={item.completed ? "completed" : ""}>
                    {item.text}
                  </p>
                  <Trash onClick={() => removeTask(item.id)} />
                </div>
              ))}
            </div>
            <textarea
              text={"Add a Task"}
              placeholder="Enter task"
              onChange={(e)=>setSubData(e.target.value)}
              value={subData}
            />
            <button onClick={subTask}>Add Subtask</button>
          </div>
        </div>
        <div className="right-class">
          <button className="btn-close" onClick={onClose} ></button>
          <p>Add to card</p>
          <button className="model-btn" onClick={() => setShowDropdown(!showDropdown)}>
            <FiUsers />&nbsp;
            Members
          </button>
          {showDropdown && (
            <Dropdown className="member-dropdown">
              <input type="search"
                placeholder="Search members"
              />
              <h6>Board members</h6>
              {
                boardMember?.member?.map((item, index) => (
                  <div key={index} className="dropdown-item">
                    <div className="member__email">
                      {item.email}
                    
                    </div>
                  </div>
                ))

              }

            </Dropdown>
          )}
          <button className="model-btn">
            <MdOutlineLabel />&nbsp;
            Lables
          </button>
          <button className="model-btn">
            <GoChecklist />&nbsp;
            Checklist
          </button>
          <button className="model-btn">
            <BsCalendarDate />&nbsp;
            Date
          </button>
          <label className="modl-btn" for="file_upload" ><GrAttachment />&nbsp; Attachment </label>
          <input type="file" id="file_upload" onChange={handleImage} style={{ display: "none" }} />
          <button className="model-btn">
            <FaCcDiscover />&nbsp;
            Cover
          </button>
          <button className="model-btn">
            <AiOutlineFileDone />&nbsp;
            Custom Fileds
          </button>
          <button className="model-btn" onClick={() => setAssign(!assignn)}>
            <CgProfile />&nbsp;
            Assign to
          </button>
          {assignn ? (
            <Select
              // defaultValue={[colourOptions[2], colourOptions[3]]}
              name="colors"
              options={
                boardMember?.member?.map((item) => {
                  return { value: item, label: item.email }
                }
                )
              }
              className="basic-multi-select"
              classNamePrefix="select"
              onChange={(e) => updateAssign(e.value)}
            />

          ) : ""
          }
          <div className="points">
            <CustomInput
              text={"Add Points"}
              placeholder="Enter Points"
              onSubmit={updatePoints}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default CardInfo;
